import { formatNumber } from '@telerik/kendo-intl'
import React, { useEffect, useRef, useState } from 'react'

export default function NumericInput(props) {

    const { format, disable, value, onChange, maxLength, ...otherProps } = props;

    const [cursor, setCursor] = useState(null);
    const ref = useRef(null);

    useEffect(() => {
        const input = ref.current;
        if (input) {
            input.setSelectionRange(cursor, cursor);
        }
    }, [ref, cursor, value])

    const previousValue = value;

    const handleChange = (e) => {
        let value = e.target.value.replace(/[^\-\.0-9]/g, '');
        let isNegative = value.startsWith("-");
        if (isNegative && value.length === 1) {
            value = "-0";
        }
        if (value.trim() !== "-" && isNaN(value)) {
            const cursorPosition = e.target.selectionStart - 1;
            ref.current.setSelectionRange(cursorPosition, cursorPosition);
            return;
        }
        const valueBeforeDecimal = value.split('.')[0];
        if (
            valueBeforeDecimal.length === 0
        ) {
            e.target.value = "";
            onChange(e);
            return;
        }
        let cursorPosition = e.target.selectionStart;
        if (valueBeforeDecimal.length > maxLength) {
            cursorPosition--;
            ref.current.setSelectionRange(cursorPosition, cursorPosition);
            return;
        }
        const previousValueBeforeDecimal = previousValue.split('.')[0];
        if (valueBeforeDecimal.length > 1 && valueBeforeDecimal.length % 3 === 1) {
            if (String(previousValueBeforeDecimal).length < String(valueBeforeDecimal).length) {
                cursorPosition++;
            }
        }
        if (valueBeforeDecimal.length > 1 && previousValueBeforeDecimal.length % 3 === 1 && valueBeforeDecimal.length % 3 === 0) {
            cursorPosition--;
        }
        setCursor(cursorPosition);
        e.target.value = value;
        onChange(e);
    }

    return (
        <input
            {...otherProps}
            ref={ref}
            disabled={disable}
            value={value ? formatNumber(Number(value), format) : ""}
            onChange={handleChange}
        />
    )
}
